
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '@/config/msalConfig';

interface LoginPageProps {
  reason?: string | null;
  returnTo?: string | null;
}

export default function LoginPage({ reason, returnTo }: LoginPageProps = {}) {
  const { instance } = useMsal();

  const handleLogin = () => {
    // If we have a returnTo URL, store it so we can redirect after login
    if (returnTo) {
      sessionStorage.setItem('loginReturnTo', returnTo);
    }
    instance.loginRedirect(loginRequest);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[var(--bg-page)]">
      <div className="max-w-sm w-full mx-4">
        <div className="bg-[var(--bg-card)] rounded-xl shadow-lg p-8 text-center">
          {/* Session expired banner */}
          {reason === 'session_expired' && (
            <div className="mb-6 px-4 py-3 bg-amber-50 border border-amber-200 rounded-lg">
              <p className="text-sm text-amber-700 font-medium">
                Your session has expired. Please sign in again to continue.
              </p>
            </div>
          )}

          {/* Logo / Branding */}
          <div className="mb-6">
            <img src="/ns-logo.png" alt="Ned Stevens" className="h-14 w-auto mx-auto mb-4" />
            <h1 className="text-xl font-semibold text-[var(--text-primary)]">Ned&apos;s Home</h1>
            <p className="text-sm text-[var(--text-secondary)] mt-1">Analytics Platform</p>
          </div>

          {/* Sign In Button */}
          <button
            onClick={handleLogin}
            className="w-full flex items-center justify-center gap-3 px-4 py-3 bg-[#0078d4] hover:bg-[#106ebe] text-white rounded-lg font-medium transition-colors text-sm"
          >
            {/* Microsoft logo */}
            <svg width="20" height="20" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="1" y="1" width="9" height="9" fill="#f25022"/>
              <rect x="11" y="1" width="9" height="9" fill="#7fba00"/>
              <rect x="1" y="11" width="9" height="9" fill="#00a4ef"/>
              <rect x="11" y="11" width="9" height="9" fill="#ffb900"/>
            </svg>
            Sign in with Microsoft
          </button>
        </div>
      </div>
    </div>
  );
}
